import { render } from "./MemosIndex.vue?vue&type=template&id=72b3bc4c&scoped=true"
import script from "./MemosIndex.vue?vue&type=script&lang=js"
export * from "./MemosIndex.vue?vue&type=script&lang=js"

import "./MemosIndex.vue?vue&type=style&index=0&id=72b3bc4c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b3bc4c"]])

export default __exports__